<template>
  <div class="notice-list mt20">
    <div class="imgLeft">
      <img :src="getworkDynamicsList.img" style="width: 220px;height: 100%;" />
      <img
        class="btn"
        :src="getworkDynamicsList.btn"
        style="width: 140px;height: 40px;"
        @click="handleViewAll(getworkDynamicsList.source)"
      />
    </div>
    <div class="right">
      <div class="workDynamics">
        <ul>
          <li
            v-for="(item2, index2) in getworkDynamicsList.list"
            class="ellipsis ccui-clearfix"
            :key="index2"
          >
            <a @click="handleOp(item2, getworkDynamicsList.source)">
              <span class="ellipsis" :title="item2.cont">{{ item2.cont }}</span
              ><span style="color:#999999;">[{{ item2.time }}]</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- <el-link
      :underline="false"
      type="info"
      class="notice-list-view-all"
      @click="handleViewAll(getworkDynamicsList.source)"
      >更多 ></el-link
    > -->
  </div>
</template>

<script>
export default {
  name: "noticeList",
  props: ["workDynamicsList"],
  data() {
    return {
      tabName: "first",
      nodeList: [],
      agentIdEncrypt: ""
    };
  },
  computed: {
    getworkDynamicsList() {
      return this.workDynamicsList;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    handleOp(row, source) {
      this.$router.push({
        path: "/announcementDetail",
        query: {
          id: row.id,
          source: source,
          type: row.type,
          schemeId: row.schemeId
        }
      });
    },
    handleViewAll(source) {
      this.$router.push({
        path: "/announcementsList",
        query: {
          source: source
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.mt20 {
  margin-top: 20px;
  display: flex;
}
.imgLeft {
  flex: 1.5;
  position: relative;
  .btn {
    cursor: pointer;
    position: absolute;
    left: 49px;
    bottom: 20px;
  }
}
.right {
  flex: 6.5;
}
.notice-list {
  height: 240px;
  width: 100%;
  background: linear-gradient(180deg, #f8fcff 0%, #ffffff 100%);
  position: relative;
  border-top: 1px solid #0089ef;
}
.workDynamics {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  padding: 37px 20px;
  box-sizing: border-box;
  overflow: hidden;
  ul {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      width: 435px;
      height: 18px;
      margin-bottom: 18px;
      margin-right: 10px;
      line-height: 18px;
      // font-family: PingFangSC-Regular;
      font-family: PingFangSC, PingFang SC;
      font-style: normal;
      font-size: 13px;
      color: #4a4a4a;
      font-weight: 400;
    }
    li a {
      display: flex;
      justify-content: space-between;
      &:hover {
        color: #0089ef;
      }
      span:first-of-type {
        width: 350px;
      }
      span:last-child {
        padding-right: 19px;
      }
    }
  }
}
/deep/ .el-tabs__header {
  margin-bottom: 25px;
}
.icon-notice-list {
  position: absolute;
  left: 20px;
  top: 16px;
  color: #0089ef;
}
</style>
